export enum IconsEnum {
  Amediateka = 'amediateka',
  Moretv = 'moretv',
  Start = 'start',
  STANDART = 'standart',
}

export enum PeriodEnum {
  Month = 'month',
  Year = 'year',
}

export enum AmountTypeEnum {
  PERCENT = 'percent',
  ABSOLUTE = 'absolute',
}
